module.exports = __webpack_public_path__ + "img/Tessellate-01.fb54eb93.jpg";